import { render, staticRenderFns } from "./App-block-card-small.vue?vue&type=template&id=77e8c9b0&scoped=true&"
import script from "./App-block-card-small.vue?vue&type=script&lang=ts&"
export * from "./App-block-card-small.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-card-small.vue?vue&type=style&index=0&id=77e8c9b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e8c9b0",
  null
  
)

export default component.exports